export const isRequired = (field) => `${field || 'This'} is a required field`;
export const noNegative = (field) => `${field || 'Value'} cannot be negative`;
export const noZero = (field) => `${field || 'Value'} cannot be zero`;
export const isInvalid = (field) => `Invalid value${field ? ` for ${field}` : ''}`;
export const invalidEmail = () => 'Invalid email';
